<template>
  <transition-group name='fade'>
    <div @click="defaultMask" @touchmove.prevent class="mask" key="1" v-if="show"></div>
    <div class="parameter-pop" key="2" v-show="show"  >
      <div class="parameter-pop-title">
        参数设置
      </div>
      <div class="parameter-pop-content">
        <div class="parameterPop-content-row">
          <div class="parameterContent-row">
            <span class="row-title">控制方式</span>
            <span class="row-input">
               <el-select @change="selectVersion($event)" v-model="version" placeholder="请选择">
                 <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
               </el-select>
            </span>
          </div>
        </div>
        <div class="parameterPop-content-row">
          <div class="parameterContent-row">
            <span class="row-title">开启时长</span>
            <span class="row-input"><el-input type="number" placeholder="0" v-model="openTime" @change="openTimeInput" clearable ></el-input></span>
            <span class="row-tag">(1~500)</span>
          </div>
          <div class="parameterContent-row">
            <span class="row-title">上传周期</span>
            <span class="row-input"><el-input type="number" placeholder="0" v-model="sleepTime" @change="sleepTimeInput" clearable></el-input></span>
            <span class="row-tag">(1~180)</span>
          </div>
        </div>
        <div class="parameterPop-content-row">
          <div class="parameterContent-row">
            <span class="row-title">定时开启(时)</span>
            <span class="row-input"><el-input type="number" placeholder="0" v-model="hourOpenTime" @change="hourOpenTimeInput" clearable></el-input></span>
            <span class="row-tag">(0~23)</span>
          </div>
          <div class="parameterContent-row">
            <span class="row-title">定时开启(分)</span>
            <span class="row-input"><el-input type="number" placeholder="0" v-model="minOpenTime" @change="minOpenTimeInput" clearable></el-input></span>
            <span class="row-tag">(0~59)</span>
          </div>
        </div>
        <div class="parameterPop-content-row">
          <div class="parameterContent-row">
            <span class="row-title">光控开启电压</span>
            <span class="row-input"><el-input type="number" placeholder="0" v-model="openVoltage" clearable @change="openVoltageInput"></el-input></span>
            <span class="row-tag">(0~33)</span>
          </div>
          <div class="parameterContent-row">
            <span class="row-title">光控延时时间</span>
            <span class="row-input"><el-input type="number" placeholder="0" v-model="openDelaytime" clearable @change="openDelayTimeInput"></el-input></span>
            <span class="row-tag">(1~180)</span>
          </div>
        </div>
      </div>
      <div class="parameter-pop-btn">
        <el-button @click="btnOK">确定</el-button>
        <el-button @click="btnCancel">取消</el-button>
      </div>
    </div>
  </transition-group>
</template>

<script>
  import {clientInfo, getAttributesClient, getCredentials} from "../../untils/api/home";

  export default {
    name: 'parameterSet',
    data() {
      return {
        show: false,
        deviceInfo: {},
        options: [{
          value: 2,
          label: '光控'
        }, {
          value: 3,
          label: '时控'
        }],
        version: 2,
        openTime: 240,
        hourOpenTime: 18,
        sleepTime: 1,
        minOpenTime: 0,
        openVoltage: 14,
        openDelaytime: 30,
        time: 0,
        parameterJson: {},
        parameterCredentialsId: '',
        switchFlg: 3,
        time: 0,
      }
    },
    mounted() {
      if (window.history && window.history.pushState) {
        window.addEventListener("popstate", this.defaultMask, false);
      }

      this.getParameterCredentialsId();
    },

    destroyed() {
      window.removeEventListener("popstate", this.defaultMask, false);
    },


    methods: {
      openTimeInput(value) {
        let min = 1;
        let max = 500;
        if(value < min || value > max) {
          this.$message({
            showClose: true,
            type: "warning",
            message: "开启时长范围在1~500之间"
          });
        }
        if(value < min) {
          this.openTime = min;
        } else if(value > max) {
          this.openTime = max;
        }

        this.openTime = Math.floor(this.openTime);
      },

      hourOpenTimeInput(value) {
        let min = 0;
        let max = 23;
        if(value < min || value > max) {
          this.$message({
            showClose: true,
            type: "warning",
            message: "定时开启(时)范围在0~23之间"
          });
        }
        if(value < min) {
          this.hourOpenTime = min;
        } else if(value > max) {
          this.hourOpenTime = max;
        }

        this.hourOpenTime = Math.floor(this.hourOpenTime);
      },

      sleepTimeInput(value) {
        let min = 1;
        let max = 180;
        if(value < min || value > max) {
          this.$message({
            showClose: true,
            type: "warning",
            message: "上传周期范围在0~23之间"
          });
        }
        if(value < min) {
          this.sleepTime = min;
        } else if(value > max) {
          this.sleepTime = max;
        }

        this.sleepTime = Math.floor(this.sleepTime);
      },

      minOpenTimeInput(value) {
        let min = 0;
        let max = 59;
        if(value < min || value > max) {
          this.$message({
            showClose: true,
            type: "warning",
            message: "定时开启(分)范围在0~59之间"
          });
        }
        if(value < min) {
          this.minOpenTime = min;
        } else if(value > max) {
          this.minOpenTime = max;
        }

        this.minOpenTime = Math.floor(this.minOpenTime);
      },

      openVoltageInput(value) {
        let min = 0;
        let max = 33;
        if(value < min || value > max) {
          this.$message({
            showClose: true,
            type: "warning",
            message: "光控开启电压范围在0~33之间"
          });
        }
        if(value < min) {
          this.openVoltage = min;
        } else if(value > max) {
          this.openVoltage = max;
        }

        this.openVoltage = Math.floor(this.openVoltage);
      },

      openDelayTimeInput(value) {
        let min = 1;
        let max = 180;
        if(value < min || value > max) {
          this.$message({
            showClose: true,
            type: "warning",
            message: "光控延时时间范围在1~180之间"
          });
        }
        if(value < min) {
          this.openDelaytime = min;
        } else if(value > max) {
          this.openDelaytime = max;
        }

        this.openDelaytime = Math.floor(this.openDelaytime);
      },

      btnOK() {
        this.setParameterJson();
        this.setParameterClintInfo();
        this.show = false;
      },

      selectVersion(event) {
        this.version = event;
      },

      setParameterJson() {
        this.parameterJson.op_fl = this.switchFlg;
        this.parameterJson.op_t = parseInt(this.openTime);
        this.parameterJson.h_op_t = parseInt(this.hourOpenTime);
        this.parameterJson.m_op_t = parseInt(this.minOpenTime);
        this.parameterJson.sT = parseInt(this.sleepTime);
        this.parameterJson.opVol = parseInt(this.openVoltage);
        this.parameterJson.opDt = parseInt(this.openDelaytime);
        this.parameterJson.ver = this.version;
        if(this.time != 0) {
          this.parameterJson.time = this.time;
        }
      },

      getParameterCredentialsId() {
        getCredentials(this.deviceInfo.id).then(response => {
          this.parameterCredentialsId = response.credentialsId;
          this.getParameterClientInfo();
        }).catch(error => {
          console.log("error",error);
        })
      },

      getParameterClientInfo() {
        getAttributesClient(this.parameterCredentialsId).then(response => {
          this.switchFlg = 3;
          this.openTime = 240;
          this.hourOpenTime = 18;
          this.minOpenTime = 0;
          this.sleepTime = 1;
          this.openVoltage = 14;
          this.openDelaytime = 30;
          this.version = 2;
          this.time = 0;
          if(response.client != undefined) {
            for (let obj in response.client) {
              if(obj === 'cmd') {
                let json = JSON.parse(response.client[obj]);
                this.switchFlg = json.op_fl;
                this.openTime = json.op_t;
                this.hourOpenTime = json.h_op_t;
                this.minOpenTime = json.m_op_t;
                this.sleepTime = json.sT;
                this.openVoltage = json.opVol;
                this.openDelaytime = json.opDt;
                json.time === undefined ? this.time = 0 : this.time = json.time;
                this.version = json.ver;
              }
            }
          }
        }).catch(error => {
          console.log("error", error)
        })
      },

      setParameterClintInfo() {
        let cmdJson = {};
        cmdJson.cmd = JSON.stringify(this.parameterJson);
        clientInfo(this.parameterCredentialsId, cmdJson).then(response => {
          this.$message({
            showClose: true,
            type: "warning",
            message: "设置成功"
          })
        }).catch(error => {
          console.log("error", error);
          this.$message({
            showClose: true,
            type: "warning",
            message: "设置失败"
          })
        })
      },

      btnCancel() {
        this.show = false;
      },

      defaultMask() {
        this.show = false;
      }
    }
  }
</script>

<style lang="less" scoped>
  // 渐变过渡
  .fade-enter,
  .fade-leave-active {
    opacity: 0;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.35s;
  }

  .mask {
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    z-index: 1000;
    width: 100%;
    height: 100%;
  }

  .parameter-pop {
    height: 360px;
    width: 35%;
    background: #58a1ff;
    border-radius: 8px;
    position: fixed;
    top: 40%;
    left: 18%;
    z-index: 1000;
    text-align: center;

    .parameter-pop-title {
      width: 100%;
      height: 15%;
      text-align: center;
      font-size: 22px;
      padding-top: 3%;
      color: #ffffff;
    }

    .parameter-pop-content {
      width: 98%;
      height: 70%;
      margin-left: 2%;

      .parameterPop-content-row {
        width: 100%;
        height: 25%;
        display: flex;
        flex-direction: row;

        .parameterContent-row {
          width: 50%;
          height: 100%;
          font-size: 16px;
          color: #ffffff;
          padding-top: 2.5%;
          display: flex;
          flex-direction: row;

          .row-title {
            padding-top: 3%;
            width: 30%;
          }

          .row-input {
            padding-top: 1%;
            width: 40%;
          }

          .row-tag {
            padding-top: 3%;
            width: 30%;
            text-align: left
          }
        }
      }
    }

    .parameter-pop-btn {
      width: 100%;
      height: 15%;
    }


    .el-button {
      background-color: transparent;
      outline: none;
      font-size: 20px;
      appearance: none;
      -webkit-appearance: none;
      vertical-align: middle;
      text-align: center;
      margin-top: 5px;
      color: #08FEED;
      border-radius: 5px;
      border-style: ridge;
      border-color: transparent;
    }

    .el-input {
      width: 90%;
      /*margin-left: -30px;*/
      font-size: 16px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/popup/parameterSetDialog.vue